module.exports = __webpack_public_path__ + "img/paesaggio5.c2e1f93f.jpeg";